<c3-config-section-box
  [title]="TP_SECTIONS_INFO['education-contextual'].label"
  [icon]="TP_SECTIONS_INFO['education-contextual'].icon"
>
  
  <div config-description>
    <p>{{ TP_SECTIONS_INFO["education-contextual"].description }}</p>

    
  </div>

  <div [c3ConfigForm]="this">
    <c3-warnings-selectable-list
      [availableWarnings]="availableWarnings$ | async"
      [filters]="['patient', context$ | async]"
      [(ngModel)]="selection"
      (ngModelChange)="onSelectionChange()"
    >
    </c3-warnings-selectable-list>
  </div>
</c3-config-section-box>
